/**************************************************
 * Nombre:       Formulario_Habitaciones_Fotos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoImagenCropLista from "../../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Habitaciones_Fotos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCropLista dato={'imgs'} {...props} ancho={35} alto={46}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Habitaciones_Fotos